<template>
  <div class="order-page pl-4">
    <div class="animated-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <div class="page-header">
      <div class="header-content px-2">
        <div class="d-flex">
          <h1>Mengubah Staff</h1>
          <div class="header-badge ml-2">
            <v-icon size="14" color="white">mdi-account-edit</v-icon>
            <span>Ubah</span>
          </div>
        </div>
        <p>Ubah data pribadi dan data pegawai staff</p>
      </div>
    </div>

    <ValidationObserver ref="form">
      <v-form @submit.prevent="save">
        <div class="main-card">
          <!-- Section: Data Pribadi -->
          <div class="form-section">
            <div class="step-header">
              <div class="step-icon teal">
                <v-icon color="white" size="28">mdi-account-outline</v-icon>
              </div>
              <div>
                <h2>Data Pribadi</h2>
                <p>Nama, kontak, alamat, dan data rekening</p>
              </div>
            </div>

            <div class="form-grid">
              <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-account</v-icon></span>
                    Nama
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.name"
                    placeholder="Nama"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Kode" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-barcode</v-icon></span>
                    Kode
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.code"
                    placeholder="Kode"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-email-outline</v-icon></span>
                    Email
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.email"
                    placeholder="Contoh. XXXX@gmail.com"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Mobilephone" rules="required|min:10|max:13" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-phone</v-icon></span>
                    Mobilephone
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.mobilephone"
                    placeholder="Contoh. 081XXXXXXXXX"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    type="number"
                    min="0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Jenis Kelamin" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-gender-male-female</v-icon></span>
                    Jenis Kelamin
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-select
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.gender"
                    :items="['Laki-Laki', 'Perempuan']"
                    placeholder="Pilih jenis kelamin"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-select>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Alamat" rules="required" v-slot="{ errors }">
                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-map-marker</v-icon></span>
                    Alamat
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-textarea
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.address"
                    placeholder="Alamat"
                    rows="2"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-textarea>
                </div>
              </ValidationProvider>

              <ValidationProvider name="NIK" rules="required|min:16|max:16" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-card-account-details</v-icon></span>
                    NIK
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.nik"
                    placeholder="No. NIK (16 digit)"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    type="number"
                    min="0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="No. Rekening" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-credit-card-outline</v-icon></span>
                    No. Rekening
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.rek_number"
                    placeholder="No. Rekening"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    type="number"
                    min="0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Nama Rekening" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-account-tie</v-icon></span>
                    Nama Rekening
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.rek_name"
                    placeholder="Nama Rekening"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-text-field>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Nama Bank" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-bank</v-icon></span>
                    Nama Bank
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.bank_name"
                    :items="['BRI', 'BCA', 'CIMB', 'BNI', 'Mandiri', 'BTN', 'Danamon', 'Maybank', 'OCBC NISP', 'Panin', 'Permata', 'BTPN']"
                    placeholder="Contoh. BRI"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-autocomplete>
                </div>
              </ValidationProvider>

              <div class="form-field">
                <label>
                  <span class="field-icon"><v-icon size="16">mdi-calendar</v-icon></span>
                  Tanggal Bergabung
                  <span class="badge-required">Wajib</span>
                </label>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider name="Tanggal Bergabung" rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-model="form.join_date"
                        v-on:keyup.enter="save()"
                        placeholder="Tanggal Bergabung"
                        solo
                        flat
                        dense
                        hide-details="auto"
                        class="elegant-input"
                        background-color="#f8f9fa"
                        :error-messages="errors"
                        readonly
                        v-bind="attrs"
                        v-on="on">
                      </v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    v-model="form.join_date"
                    @input="menu2 = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>

          <!-- Section: Data Pegawai & Dokumen -->
          <div class="form-section">
            <div class="step-header">
              <div class="step-icon coral">
                <v-icon color="white" size="28">mdi-briefcase-outline</v-icon>
              </div>
              <div>
                <h2>Data Pegawai & Dokumen</h2>
                <p>Cabang, kategori, supervisor, dan dokumen (foto, tanda tangan)</p>
              </div>
            </div>

            <div class="form-grid">
              <div v-if="user.id !== '1'" class="form-field">
                <label>
                  <span class="field-icon"><v-icon size="16">mdi-office-building</v-icon></span>
                  Cabang
                </label>
                <div class="branch-display">{{ user.branch_name }}</div>
              </div>
              <ValidationProvider v-if="user.id === '1'" name="Cabang" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-office-building</v-icon></span>
                    Cabang
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.branch_id"
                    :items="branch"
                    item-value="id"
                    item-text="name"
                    placeholder="Cabang"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-autocomplete>
                </div>
              </ValidationProvider>



              <ValidationProvider name="Kategori Pegawai" rules="required" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-account-group</v-icon></span>
                    Kategori Pegawai
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.category_user_id"
                    :items="category"
                    item-value="id"
                    item-text="title"
                    placeholder="Kategori Pegawai"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-autocomplete>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Supervisor" rules="" v-slot="{ errors }">
                <div class="form-field">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-account-supervisor</v-icon></span>
                    Supervisor
                  </label>
                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.spv_id"
                    :items="supervisor"
                    item-value="id"
                    item-text="name"
                    placeholder="Supervisor"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-autocomplete>
                </div>
              </ValidationProvider>

              <ValidationProvider name="Deskripsi" rules="required" v-slot="{ errors }">
                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-text</v-icon></span>
                    Deskripsi
                    <span class="badge-required">Wajib</span>
                  </label>
                  <v-textarea
                    v-on:keydown.enter.prevent="save()"
                    v-model="form.desc"
                    placeholder="Deskripsi"
                    rows="2"
                    solo
                    flat
                    dense
                    hide-details="auto"
                    class="elegant-input"
                    background-color="#f8f9fa"
                    :error-messages="errors">
                  </v-textarea>
                </div>
              </ValidationProvider>

              <div class="form-field">
                <label>
                  <span class="field-icon"><v-icon size="16">mdi-camera</v-icon></span>
                  Foto
                </label>
                <uploadfolder v-model="upload.image_url" style="height: 150px; width: 150px;">
                  <div slot="activator" class="cursor-pointer">
                    <v-card
                      flat
                      height="150"
                      class="d-flex align-center justify-center upload-card-dashed">
                      <div v-if="form.image_url.length < 1">
                        <v-icon v-if="!process.image_url" size="60" color="#718EBF">mdi-cloud-upload-outline</v-icon>
                        <v-progress-circular v-else indeterminate :color="set_color"></v-progress-circular>
                      </div>
                      <v-img v-else contain height="150" :src="form.image_url" :alt="form.image_url" class="text-center d-flex align-center">
                        <template v-slot:placeholder>
                          <v-progress-circular v-if="process.image_url" indeterminate :color="set_color"></v-progress-circular>
                        </template>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>

              <div class="form-field">
                <label>
                  <span class="field-icon"><v-icon size="16">mdi-draw</v-icon></span>
                  Tanda Tangan
                </label>
                <uploadfolder v-model="upload.ttd" style="height: 150px; width: 250px">
                  <div slot="activator" class="cursor-pointer">
                    <v-card flat height="150" class="d-flex align-center justify-center upload-card-dashed">
                      <div v-if="form.ttd.length < 1">
                        <v-icon v-if="!process.ttd" size="60" color="#718EBF">mdi-cloud-upload-outline</v-icon>
                        <v-progress-circular v-else indeterminate :color="set_color"></v-progress-circular>
                      </div>
                      <v-img v-else contain height="150" :src="form.ttd" :alt="form.ttd" class="text-center d-flex align-center">
                        <template v-slot:placeholder>
                          <v-progress-circular v-if="process.ttd" indeterminate :color="set_color"></v-progress-circular>
                        </template>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="form-actions d-flex flex-wrap align-center justify-end">
            <v-alert v-if="message.error" type="error" dense class="mb-3 mr-3" dismissible>
              {{ message.error }}
            </v-alert>
            <v-btn
              to="/user/staff"
              :disabled="process.form"
              text
              class="mr-3">
              Batal
            </v-btn>
            <v-btn
              type="submit"
              color="#00ADB5"
              class="white--text px-8"
              large
              rounded
              elevation="0"
              :loading="process.form"
              :disabled="process.form">
              <v-icon left>mdi-check-circle-outline</v-icon>
              Simpan
            </v-btn>
          </div>
        </div>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,


        form: {
          id: '',
          par_id: '0',
          category_user_id: '',
          branch_id: '',
          code: '',
          name: '',
          mobilephone: '',
          address: '',
          gender: '',
          email: '',
          nik: '',
          rek_number: '',
          rek_name: '',
          join_date: '',
          bank_name: '',
          image_url: '',
          desc: '',
          ttd: '',
          spv_id: '',
        },
        category: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          ttd: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ttd': {
        handler: function () {
          if (this.upload.ttd) {
            this.process.ttd = this.upload.ttd.process

            if (!this.process.ttd) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.ttd = this.upload.ttd.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.form = res.results.data
            this.form.id = res.results.data.id
            this.form.par_id = res.results.data.par_id
            this.form.category_user_id = res.results.data.category_user_id
            this.form.branch_id = res.results.data.branch_id
            this.form.code = res.results.data.code
            this.form.name = res.results.data.name
            this.form.mobilephone = res.results.data.mobilephone
            this.form.address = res.results.data.address
            this.form.gender = res.results.data.gender
            this.form.email = res.results.data.email
            this.form.nik = res.results.data.nik
            this.form.rek_number = res.results.data.rek_number
            this.form.rek_name = res.results.data.rek_name
            this.form.join_date = res.results.data.join_date
            this.form.bank_name = res.results.data.bank_name
            this.form.image_url = res.results.data.image_url
            this.form.desc = res.results.data.desc
            this.form.ttd = res.results.data.ttd

          }
        this.fetchCatrgory()
        this.fetchCabang()
        this.fetchSupervisor()
        })
      },
      async fetchCatrgory() {

         let params = {
          limit: 10000000000000,
          'id[nin]': '1,8'
        }

        await get(`admin/category_user/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },
      async fetchCabang() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/branch/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.branch = res.results.data
          }
        })
      },
      async fetchSupervisor() {

          let params = {
          limit: 10000000000000,
          is_active: 'Aktif',
          'category_user_id': '5'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.supervisor = res.results.data
          }
        })
      },
      
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/user/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/user/staff' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style scoped>
.order-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
  background: linear-gradient(180deg, #fcfcfc 0%, #f8fafa 100%);
}

.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

.page-header {
  position: relative;
  z-index: 1;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  border-radius: 20px;
}

.header-badge span {
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

.form-section {
  padding: 24px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f8f9fa;
}

.step-icon {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.teal {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
}

.step-icon.coral {
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
}

.step-header h2 {
  font-size: 14px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.step-header p {
  font-size: 12px;
  color: #393E46;
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-field.full-width {
  grid-column: span 2;
}

.form-field label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #222831;
  margin-bottom: 10px;
}

.field-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #f8f9fa;
  border-radius: 6px;
}

.field-icon .v-icon {
  color: #393E46 !important;
}

.badge-required {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  color: #EA5455;
  background: rgba(234, 84, 85, 0.1);
  padding: 3px 8px;
  border-radius: 4px;
}

.branch-display {
  font-size: 14px;
  font-weight: 600;
  color: #222831;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e8eaed;
}

.upload-card-dashed {
  border-radius: 12px;
  border: 2px dashed #eaeaea;
}

.elegant-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 44px !important;
  border: 1px solid #e8eaed !important;
  background: #fafbfc !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.elegant-input >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
  border-color: #00ADB5 !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.12) !important;
}

.form-actions {
  padding: 24px;
  border-top: 1px solid #f0f0f0;
}

@media (max-width: 960px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-field.full-width {
    grid-column: span 1;
  }
}
</style>